import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Role } from '@enums/role.enum';
import { MenuItem, MenuItemPath, MenuItemRoute } from '@enums/menu-item.enum';
import { TranslateService } from '@ngx-translate/core';
import { UiService } from 'app/core/services/ui.service';
import { HomeButton } from '../../models/home-button';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  styles: [`
  >>> app-home {
    display: flex;
    height: 100%;
    flex-wrap: wrap;
    margin: auto;
  }
`]
})
export class HomeComponent implements OnInit {

Role = Role;

  constructor(
    private translate: TranslateService,
    private router: Router,
    public uiService: UiService
  ) { }

  ngOnInit() {

  }

  onNewTonnage() {
    this.router.navigate([MenuItemPath.get(MenuItem.tonnage)]);
  }
  onNewToll() {
    this.router.navigate([MenuItemPath.get(MenuItem.toll)]);
  }

}
